import { useQueryClient, useMutation } from '@tanstack/react-query';
import { createMultipleSessions } from '../utils/Network';
import { TimeFrame, GSELevel } from '@utils/types';

type savePrivateSessionRequest = {
  groupId: number;
  timeFrame: TimeFrame;
  GSELevels: GSELevel[];
  userToken: string;
};

const _savePrivateSession = async (data: savePrivateSessionRequest) => {
  return createMultipleSessions(data.groupId, data.timeFrame, data.GSELevels, data.userToken);
};

const useSavePrivateSession = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: _savePrivateSession,
    onSettled: () => {
      // Invalidate all sessions to refresh the calendar and lists
      queryClient.invalidateQueries({
        queryKey: ['sessions'],
      });
      // Invalidate privateGroupHasSessions to update "has sessions" state
      queryClient.invalidateQueries({
        queryKey: ['privateGroupHasSessions'],
      });
      // Invalidate privateGroups to refresh group data
      queryClient.invalidateQueries({
        queryKey: ['privateGroups'],
      });
    },
  });
};

export default useSavePrivateSession;
